/**
 * The IAP cover sheet's identity in the shared form version table.
 *
 * Mirrors `IAP_COVER_BASE_ID` and `IAP_COVER_IC_APPROVAL_ROLE` on the server. Kept in its own module so the approval
 * table and the card can both read them without importing each other.
 */

export const IAP_COVER_BASE_ID = 'IAP_COVER';

/** Stored role for box 4, shared with the FEMA 202's Incident Commander approval. */
export const IAP_COVER_IC_APPROVAL_ROLE = 'Incident Commander';
